import React from 'react';

import type { VmsVendorSource } from '@vlabs/api/point-api/model';
import Loader from '@vlabs/shared/legacy-components/loader/Loader';
import { HLSVideoPlayer } from '@vlabs/shared/video-player/HLSVideoPlayer';
import { WsVideoPlayer } from '@vlabs/shared/video-player/WsVideoPlayer';

import { useVideoArchiveTranslation } from './i18n';
import { useArchiveSource } from './useArchiveSource';
import st from './VideoArchiveWidget.module.sass';

interface VideoArchiveWidgetProps {
  vmsSource: VmsVendorSource | null;
  startTime?: string | null;
}

export function VideoArchiveWidget({
  vmsSource,
  startTime = undefined,
}: VideoArchiveWidgetProps): React.JSX.Element {
  const { t } = useVideoArchiveTranslation();

  const {
    archivePath,
    isError,
    isLoading,
  } = useArchiveSource(vmsSource, startTime);

  if (isLoading) {
    return (
      <div className={st.EmptyPanel}>
        <Loader />
      </div>
    );
  }

  if (isError) {
    return (
      <div className={st.EmptyPanel}>
        {t('loading_error')}
      </div>
    );
  }

  return (
    <React.Fragment>
      {!!archivePath?.hls && (
        <HLSVideoPlayer
          isArchive
          src={archivePath.hls}
        />
      )}
      {!!archivePath?.ws && <WsVideoPlayer wsUrl={archivePath.uiWsUrl} />}
    </React.Fragment>
  );
}
